import { Component, ContentChild, HostBinding, ViewEncapsulation } from '@angular/core';
import { CaInputComponent } from '../input/input.component';

@Component({
  selector: 'ca-form-field',
  templateUrl: './form-field.component.html',
  styleUrls: ['./form-field.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CaFormFieldComponent {
  @ContentChild(CaInputComponent)
  caInput!: CaInputComponent;

  @HostBinding('class.error') get hasError() {
    return (
      (this.caInput?.ngControl?.dirty || this.caInput?.ngControl?.touched) &&
      this.caInput?.ngControl?.invalid
    );
  }

  get error() {
    const errors = Object.entries(this.caInput?.ngControl?.control.errors ?? {});
    if (!this.caInput?.ngControl?.dirty && !this.caInput?.ngControl?.touched) {
      return '';
    }
    if (!errors.length) {
      return null;
    }
    return errors[0][0];
  }
}
